type View = 'immersive' | 'overview';
interface ViewState {
  inInterior?: boolean;
  inInteriorSea?: boolean;
  interiorView?: string;
  viewMode?: string;
}

/** Interior cameras belong to the current scene, including on a whole-city planet. */
export function currentPlanetView(state: ViewState | null | undefined, globe: boolean): View | 'globe' {
  if (state?.inInterior) return state.interiorView === 'overview' ? 'overview' : 'immersive';
  if (!state?.inInteriorSea && globe) return 'globe';
  return state?.viewMode === 'overview' ? 'overview' : 'immersive';
}

export function selectPlanetView(
  scene: (ViewState & { toggleView(): void }) | null,
  view: View,
  globe: boolean,
  returnToDistrict: () => void,
): void {
  if (!scene) return;
  if (!scene.inInterior && !scene.inInteriorSea && globe) {
    returnToDistrict();
    return;
  }
  if ((scene.inInterior ? scene.interiorView : scene.viewMode) !== view) scene.toggleView();
}
